import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//i18n
import { withTranslation } from "react-i18next";
import {
  apiErrorrHandler,
  encryptText,
  findDateDifference,
  NotificationMessage,
} from "utils";
import MultiSkeleton from "components/TP/Common/MultiSkeleton";
import { generalPaths } from "common/data/routePaths";
import { useDispatch, useSelector } from "react-redux";
import { getNotifications } from "store/actions";
import NotificationSound from "./NotificationSound";
import { updateNotificationsRead } from "helpers/General/notifications_helpers";
import { LoadingModal } from "components/TP/Common/Modals";

const NotificationDropdown = (props) => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const dispatch = useDispatch();

  const { notifications, loading } = useSelector((state) => ({
    notifications: state.Notifications.notifications,
    loading: state.Notifications.loading,
  }));

  useEffect(() => {
    if (notifications.length === 0) {
      dispatch(getNotifications());
    }
  }, [notifications.length]);

  const handleRedirect = (notificationId, notificationTitle) => {
    const fnolNumber = notificationTitle?.split("#")[1];
    if (fnolNumber) {
      window.open(
        `${generalPaths.notificationsLogs}/search-results/${encryptText(
          fnolNumber
        )}`,
        "_blank"
      );
    }
    setMenu(false);
    changeNotficationsRead(notificationId);
  };

  // patch update is_read of notification
  // if markAll as unread make is_read = 0 if markAll as read make is_read=1
  const changeNotficationsRead = async (notificationsId) => {
    try {
      setIsUpdating(true);
      await updateNotificationsRead({
        notification_logs_ids: [notificationsId],
        data: { is_read: 1 },
      });
      NotificationMessage(
        "success",
        "Notifications Marked As Read Successfully"
      );
      dispatch(getNotifications());
    } catch (error) {
      const errorMessage = apiErrorrHandler(error);
      NotificationMessage("Error", errorMessage);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
          disabled={notifications.length === 0}
        >
          <i className="bx bx-bell bx-tada" />
          {/* Number of Notifications */}
          {/* <span className="badge bg-danger rounded-pill">1</span> */}
          {notifications.length > 0 ? (
            <span className="badge">
              {notifications.length >= 50 ? `50+` : notifications.length}
            </span>
          ) : null}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0">Notifications </h6>
              </Col>
              <div className="col-auto">
                <Link
                  to={generalPaths.dropdownNotifications}
                  className="small"
                  target="_blank"
                >
                  View All
                </Link>
              </div>
            </Row>
          </div>

          <SimpleBar
            style={{ height: notifications.length >= 3 ? "200px" : "auto" }}
          >
            {loading ? <MultiSkeleton length={5} /> : null}
            {!loading &&
              notifications.length > 0 &&
              notifications.map((notification) => (
                <span
                  key={notification.id}
                  // to={`${motorPaths.fnol}/edit/${encryptText(
                  //   notification?.resource_id
                  // )}`}
                  onClick={() =>
                    handleRedirect(
                      notification?.notification_logs[0]?.id,
                      notification?.title
                    )
                  }
                  // target="_blank"
                  className="text-reset notification-item"
                >
                  <div className="d-flex">
                    <div className="avatar-xs me-3">
                      <span className="avatar-title bg-success rounded-circle font-size-16">
                        <i className="bx bx-badge-check" />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1">{notification?.title}</h6>
                      <div className="font-size-12 text-muted">
                        {/* <p className="mb-1">{notification.description}</p> */}
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          {findDateDifference(notification?.created_at)}
                        </p>
                      </div>
                    </div>
                  </div>
                </span>
              ))}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 text-center"
              to={generalPaths.dropdownNotifications}
              target="_blank"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              <span key="t-view-more">{props.t("View More..")}</span>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
      {/* notification Sound */}
      <NotificationSound />

      <LoadingModal isOpen={isUpdating} />
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any,
};
